(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flappie-cat-id-protection"] && !Shopify.designMode) return;
  try {
    
(() => {
const mounted = new WeakMap();
function mount(host) {
if (mounted.has(host)) return;
const destroy = (() => {
const abort = new AbortController(); const signal = abort.signal;
const copy = JSON.parse(host.querySelector("[data-study-copy]").textContent);
const $ = (s, root = host) => root.querySelector(s);
const $$ = (s, root = host) => [...root.querySelectorAll(s)];
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
// Both definitions are always visible. Motion starts on entry, without clicks.
const stages = $$('.m-stage');
const pauseButton = $('.m-pause');
let paused = false, animationFrame = 0, activeStage;
const routeState = new Map();
for (const stage of stages) {
  const svg = $('.m-network', stage);
  const paths = Object.fromEntries($$('[data-flow]', stage).map(path => [path.dataset.flow, path]));
  const packets = [];
  for (const route of ['face', 'prey']) for (let i = 0; i < 4; i++) {
    const el = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    el.setAttribute('r', '4.3');
    el.setAttribute('class', `m-packet m-packet-${route}`);
    el.style.opacity = 0;
    $('.m-packets', stage).append(el);
    packets.push({el, route, index: i});
  }
  routeState.set(stage, {svg, paths, packets, lengths: {}, visible: false, geometryUntil: 0});
}
function geometry(stage) {
  if (!stage || stage.closest('[hidden]')) return;
  const state = routeState.get(stage), base = stage.getBoundingClientRect();
  state.svg.setAttribute('viewBox', `0 0 ${base.width} ${base.height}`);
  const local = selector => {
    const r = $(selector, stage).getBoundingClientRect();
    return {x:r.left-base.left,y:r.top-base.top,w:r.width,h:r.height};
  };
  for (const route of ['face', 'prey']) {
    const origin = local(`.m-origin-${route}`), terminal = local(`.m-callout-${route} .m-terminal`);
    const end = {x:terminal.x+terminal.w/2,y:terminal.y+terminal.h/2};
    const start = {x:origin.x+origin.w/2,y:origin.y+origin.h/2};
    let d;
    if (matchMedia('(max-width:759px)').matches) {
      const edge = route === 'face' ? 12 : base.width-12;
      d = `M${start.x} ${start.y} C${edge} ${start.y},${edge} ${start.y+25},${edge} ${start.y+58} L${edge} ${end.y-20} Q${edge} ${end.y},${end.x} ${end.y}`;
    } else {
      const bend = route === 'face' ? -45 : 45;
      d = `M${start.x} ${start.y} C${start.x+bend} ${start.y},${end.x-bend*.7} ${end.y},${end.x} ${end.y}`;
    }
    if (state.paths[route].getAttribute('d') !== d) {
      state.paths[route].setAttribute('d',d);
      state.lengths[route] = state.paths[route].getTotalLength();
    }
  }
}
function stopAnimations() {
  cancelAnimationFrame(animationFrame); animationFrame = 0;
  for (const stage of stages) {
    stage.dataset.running = 'false';
    routeState.get(stage).packets.forEach(({el}) => el.style.opacity = 0);
  }
}
function draw(now) {
  if (!activeStage || paused || reduced.matches || document.hidden || !routeState.get(activeStage).visible) { stopAnimations(); return; }
  const state = routeState.get(activeStage);
  if (now < state.geometryUntil) geometry(activeStage);
  if (activeStage.dataset.motion === 'flow') for (const packet of state.packets) {
    const speed = packet.route === 'face' ? 1550 : 1800;
    const progress = (now / speed + packet.index*.25) % 1;
    const point = state.paths[packet.route].getPointAtLength((state.lengths[packet.route] || 0) * progress);
    packet.el.setAttribute('cx', point.x);packet.el.setAttribute('cy', point.y);
    packet.el.style.opacity = Math.min(1,progress*12+.2,(1-progress)*12+.2);
  }
  animationFrame = activeStage.dataset.motion === 'flow' || now < state.geometryUntil ? requestAnimationFrame(draw) : 0;
}
function refreshMotion() {
  const nextStage = $('.m-stage');
  if (nextStage !== activeStage) stopAnimations();
  activeStage = nextStage;
  geometry(activeStage);
  if (!activeStage) return;
  const r = $('.m-world', activeStage).getBoundingClientRect();
  const visible = r.bottom > (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0) + 30 && r.top < innerHeight-30;
  routeState.get(activeStage).visible = visible;
  if (!visible || paused || reduced.matches || document.hidden) { stopAnimations(); return; }
  activeStage.dataset.running = 'true';
  if (!animationFrame) animationFrame = requestAnimationFrame(draw);
}
let scrollFrame = 0;
function queueArt() {
  if (!scrollFrame) scrollFrame = requestAnimationFrame(() => {scrollFrame=0;refreshMotion();});
}
// The image reacts a little to the pointer; all essential motion also runs untouched.
const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
for (const stage of stages) {
  const art = $('.m-art',stage), world = $('.m-world',stage);
  world.addEventListener('pointermove', event => {
    if (!finePointer.matches || reduced.matches || paused) return;
    const r = world.getBoundingClientRect();
    art.style.setProperty('--pointer-x', `${((event.clientX-r.left)/r.width-.5)*10}px`);
    art.style.setProperty('--pointer-y', `${((event.clientY-r.top)/r.height-.5)*8}px`);
    routeState.get(stage).geometryUntil = performance.now()+360;
    if (stage.dataset.running === 'true' && !animationFrame) animationFrame = requestAnimationFrame(draw);
  });
  world.addEventListener('pointerleave', () => {
    art.style.setProperty('--pointer-x','0px');art.style.setProperty('--pointer-y','0px');
    routeState.get(stage).geometryUntil = performance.now()+360;
    if (stage.dataset.running === 'true' && !animationFrame) animationFrame = requestAnimationFrame(draw);
  });
}
const resizeObserver = new ResizeObserver(queueArt);
stages.forEach(stage => resizeObserver.observe(stage));
window.addEventListener('scroll', queueArt, {passive:true,signal});
window.addEventListener('resize', queueArt, {signal});
reduced.addEventListener('change',queueArt, {signal});
document.addEventListener('visibilitychange',() => { if (document.hidden) stopAnimations(); else queueArt(); }, {signal});
pauseButton.addEventListener('click', () => {
  paused = !paused;
  pauseButton.setAttribute('aria-pressed',String(paused));
  const label = paused ? copy.animation_resume : copy.animation_pause;
  pauseButton.setAttribute('aria-label',label);$('.m-pause-text',pauseButton).textContent=label;
  $('.m-pause-icon',pauseButton).textContent=paused?'▷':'Ⅱ';
  if (paused) for (const stage of stages) {
    $('.m-art',stage).style.setProperty('--pointer-x','0px');$('.m-art',stage).style.setProperty('--pointer-y','0px');
  }
  refreshMotion();
});
document.fonts.ready.then(() => { if (host.isConnected) requestAnimationFrame(queueArt); });

return () => { abort.abort(); stopAnimations(); cancelAnimationFrame(scrollFrame); resizeObserver.disconnect(); };
})(); mounted.set(host,destroy);
}
function all(scope) { scope.querySelectorAll('.cat-id-final-protection').forEach(mount); }
all(document);
document.addEventListener('shopify:section:load',e=>all(e.target));
document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.cat-id-final-protection').forEach(host=>{mounted.get(host)?.();mounted.delete(host);}));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flappie-cat-id-recognition"] && !Shopify.designMode) return;
  try {
    
(() => {
const mounted = new WeakMap();
function mount(host) {
if (mounted.has(host)) return;
const destroy = (() => {
const abort = new AbortController(); const signal = abort.signal;
const copy = JSON.parse(host.querySelector("[data-study-copy]").textContent);
const $ = (s, root = host) => root.querySelector(s);
const $$ = (s, root = host) => [...root.querySelectorAll(s)];
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
const section = $('#erkennung');
const surface = $('.connected-surface');
const world = $('.connection-world');
const svg = $('.data-network');
const durations = {1: 1200, 2: 1450, 3: 1700};
let variation = 3, known = true, frame = 0, inView = false, initialized = false;
let resultTimer;
const paths = Object.fromEntries($$('[data-route]').map(p => [p.dataset.route, p]));
let pathLengths = {};
const packets = [];
const clamp = v => Math.max(0, Math.min(1, v));
for (const [route, count] of [['incoming', 3], ['outgoing', 3], ['returning', 2], ['branch', 2]]) {
  for (let i = 0; i < count; i++) {
    const el = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    el.setAttribute('class', `network-packet${route === 'returning' ? ' is-return' : ''}`);
    el.setAttribute('rx', '.8');
    $('.network-packets').append(el);
    packets.push({el, route, index: i});
  }
}
function geometry() {
  const base = world.getBoundingClientRect();
  if (!base.width) return;
  const local = selector => {
    const r = $(selector).getBoundingClientRect();
    return {x: r.left - base.left, y: r.top - base.top, w: r.width, h: r.height};
  };
  const a = local('.arrival-card'), n = local('.scanner-core'), h = local('.home-stack');
  svg.setAttribute('viewBox', `0 0 ${base.width} ${base.height}`);
  let incoming, outgoing, returning, branch;
  if (base.width < 600) {
    incoming = `M${a.x + a.w} ${a.y + 50} C${n.x - 30} ${a.y + 50},${n.x - 30} ${n.y + n.h / 2},${n.x} ${n.y + n.h / 2}`;
    outgoing = `M${n.x + n.w * .68} ${n.y + n.h} C${n.x + n.w * .68} ${h.y - 14},${h.x + h.w * .74} ${h.y - 25},${h.x + h.w * .74} ${h.y}`;
    returning = `M${h.x + h.w * .43} ${h.y} C${h.x + h.w * .43} ${h.y - 23},${n.x + n.w * .25} ${h.y - 22},${n.x + n.w * .25} ${n.y + n.h}`;
    branch = `M${n.x + n.w * .9} ${n.y + n.h} Q${n.x + n.w + 8} ${h.y - 22},${h.x + h.w * .92} ${h.y + 6}`;
  } else {
    const ay = a.y + a.h * .48, ny = n.y + n.h / 2, hy = h.y + h.h * .51;
    incoming = `M${a.x + a.w} ${ay} C${a.x + a.w + 50} ${ay},${n.x - 48} ${ny},${n.x} ${ny}`;
    outgoing = `M${n.x + n.w} ${ny} C${n.x + n.w + 50} ${ny},${h.x - 52} ${hy},${h.x} ${hy}`;
    const dip = variation === 2 ? 68 : 31;
    returning = `M${h.x} ${hy + 18} C${h.x - 65} ${hy + dip},${n.x + n.w + 35} ${ny + dip},${n.x + n.w} ${ny + 18}`;
    branch = `M${n.x + n.w} ${ny - 8} C${n.x + n.w + 52} ${ny - 42},${h.x - 50} ${h.y + 24},${h.x + 8} ${h.y + 24}`;
  }
  Object.entries({incoming, outgoing, returning, branch}).forEach(([key, d]) => {
    paths[key].setAttribute('d', d);
    pathLengths[key] = paths[key].getTotalLength();
  });
}
const resizeObserver = new ResizeObserver(geometry);
resizeObserver.observe(world);
function stopMotion() {
  cancelAnimationFrame(frame);
  clearTimeout(resultTimer);
  surface.classList.remove('is-scanning', 'result-arrives', 'result-idle');
  surface.dataset.phase = 'ready';
  $('.scan-status').textContent = known ? copy.recognised : copy.no_match;
  packets.forEach(({el}) => el.style.opacity = 0);
}
function replay() {
  stopMotion();
  geometry();
  if (reduced.matches || document.hidden) return;
  surface.classList.add('is-scanning');
  surface.dataset.phase = 'input';
  $('.scan-status').textContent = copy.matching;
  const start = performance.now();
  const windows = {incoming: [-.045, .29], outgoing: [.19, .62], returning: [.59, .92], branch: [.22, .63]};
  let confirmed = false;
  function draw(now) {
    const progress = Math.min(1, (now - start) / durations[variation]);
    surface.dataset.phase = progress < .22 ? 'input' : progress < .60 ? 'compare' : progress < .92 ? 'return' : 'ready';
    for (const packet of packets) {
      const {el, route, index} = packet;
      const [from, to] = windows[route];
      const t = (progress - from - index * .045) / (to - from);
      if (t < 0 || t > 1 || (route === 'branch' && variation !== 3)) { el.style.opacity = 0; continue; }
      const length = pathLengths[route];
      const point = paths[route].getPointAtLength(length * t);
      const next = paths[route].getPointAtLength(Math.min(length, length * t + 1));
      const angle = Math.atan2(next.y - point.y, next.x - point.x) * 180 / Math.PI;
      const w = variation === 2 ? 11 : variation === 3 ? 5 : 7;
      const height = variation === 2 ? 2.5 : variation === 3 ? 5 : 3.5;
      el.setAttribute('width', w); el.setAttribute('height', height);
      el.setAttribute('x', -w / 2); el.setAttribute('y', -height / 2);
      el.setAttribute('transform', `translate(${point.x} ${point.y}) rotate(${angle})`);
      el.style.opacity = Math.min(1, t * 12 + .6, (1 - t) * 12);
    }
    if (progress >= .90 && !confirmed) {
      confirmed = true;
      surface.classList.remove('is-scanning');
      surface.classList.add('result-arrives');
      $('.scan-status').textContent = known ? copy.recognised : copy.no_match;
    }
    if (progress < 1) frame = requestAnimationFrame(draw);
    else { packets.forEach(({el}) => el.style.opacity = 0); resultTimer = setTimeout(() => { surface.classList.remove('result-arrives'); surface.classList.add('result-idle'); }, 350); }
  }
  draw(start);
}
function selectScenario(isKnown) {
  known = isKnown;
  surface.dataset.state = known ? 'known' : 'unknown';
  $('#arrival-cat').src = known ? host.dataset.knownImage : host.dataset.unknownImage;
  $('#arrival-cat').alt = known ? copy.known_alt : copy.unknown_alt;
  $('#arrival-caption').textContent = known ? copy.known : copy.unknown;
  $('#connection-result-text').textContent = known ? copy.known_result : copy.unknown_result;
  $('.result-symbol').textContent = known ? '✓' : '−';
  $('#connected-outcome').textContent = known ? copy.known_outcome : copy.unknown_outcome;
  $$('[data-scenario]').forEach(button => button.setAttribute('aria-pressed', String((button.dataset.scenario === 'known') === known)));
  replay();
}
$$('[data-scenario]').forEach(button => button.addEventListener('click', () => selectScenario(button.dataset.scenario === 'known')));
$('.replay-button').addEventListener('click', replay);
const visibilityObserver = new IntersectionObserver(entries => {
  for (const entry of entries) {
    const visible = entry.isIntersecting && entry.intersectionRatio >= .2;
    if (visible && !inView && initialized) replay();
    if (!visible) stopMotion();
    inView = visible;
  }
}, {threshold: [0, .2]});
visibilityObserver.observe(world);
document.addEventListener('visibilitychange', () => { if (document.hidden) stopMotion(); }, {signal});
reduced.addEventListener('change', () => { stopMotion(); if (!reduced.matches && inView) replay(); }, {signal});

const dialog = $('#camera-dialog'); let previousOverflow = ''; 
let lastDialogTrigger;
$$('.camera-open').forEach(button => button.addEventListener('click', () => {
  stopMotion(); lastDialogTrigger = button; previousOverflow = document.body.style.overflow; dialog.showModal(); document.body.style.overflow = 'hidden';
}));
$('.camera-close').addEventListener('click', () => dialog.close());
dialog.addEventListener('click', event => {
  if (event.target !== dialog) return;
  const r = dialog.getBoundingClientRect();
  if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
});
dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow; lastDialogTrigger?.focus({preventScroll: true}); });
$('.ambient-toggle').addEventListener('click', event => {
  const paused = surface.dataset.ambient !== 'off';
  surface.dataset.ambient = paused ? 'off' : 'on';
  event.currentTarget.setAttribute('aria-pressed', String(paused));
  event.currentTarget.textContent = paused ? copy.pulse_resume : copy.pulse_pause;
  event.currentTarget.setAttribute('aria-label', event.currentTarget.textContent);
});
document.fonts.ready.then(() => requestAnimationFrame(() => {
  if (!host.isConnected) return; initialized = true; geometry();
  if (world.getBoundingClientRect().top < innerHeight && world.getBoundingClientRect().bottom > 0) replay();
}));

return () => { abort.abort(); stopMotion(); resizeObserver.disconnect(); visibilityObserver.disconnect(); if(dialog.open) {dialog.close();document.body.style.overflow=previousOverflow;} };
})(); mounted.set(host,destroy);
}
function all(scope) { scope.querySelectorAll('.cat-id-final-recognition').forEach(mount); }
all(document);
document.addEventListener('shopify:section:load',e=>all(e.target));
document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.cat-id-final-recognition').forEach(host=>{mounted.get(host)?.();mounted.delete(host);}));
})();

  } catch(e) { console.error(e); }
})();
})();
